// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2a3zY","image":"Header_image__25VqL","name":"Header_name___Xojg","info":"Header_info__3SDiv","infoRow":"Header_infoRow__1SxiL"};